import { SpatialType } from './webSocketConnectionInfo';
import { EventRole } from './event';
import { MediaStreamWithType } from '@voxeet/voxeet-web-sdk/types/models/MediaStream';
import { IMytaverseFile } from './file';

export interface IMediaStream {
  type: 'Camera' | 'ShareScreen';
  stream: MediaStream;
  participantId: string;
  ueScreenName?: string;
}

export interface IParticipantRegion {
  timestamp: number;
  region: string;
  state: string;
  regionSpatialType?: SpatialType;
  isSeatRegion?: boolean;
}

export enum ParticipantState {
  Loading = 'LOADING',
  Loaded = 'LOADED',
}

export interface IParticipant {
  participantId: string;
  streamChatMemberId: string;
  key: string;
  email: string;
  name: string;
  firstName: string;
  lastName: string;
  fullName: string;
  avatarString: string;
  avatarImage: string;
  customAvatarUrl?: string;
  avatarId?: string;
  speaking?: boolean;
  eventId?: string | null;
  gameSessionId?: string | null;
  roomId?: string | null;
  region: IParticipantRegion | null;
  isSpeaker: boolean;
  regions: IParticipantRegion[];
  state: ParticipantState;
  dolbyParticipantId?: string | null;
  eventRole?: EventRole;
  isDemoUser?: boolean;
  mediaStream?: MediaStreamWithType;
  profileImage?: IMytaverseFile;
  company?: string;
  phoneNumber?: string;
  linkedIn?: string;
  isFacilitator?: boolean;
  handRaised?: boolean;
  handRaisedAt?: number;

  initials?: string;
}

export interface IParticipantInfo {
  [x: string]: any;

  participantId: string;
  eventId: string;
  roomId: string;
  muted: boolean;
  handRaised?: boolean;
  handRaisedAt?: number;
  sessionId?: string;
}

export interface IParticipantRoles {
  admin: string[];
  coordinator: string[];
  moderator: string[];
}

export interface IParticipantSoundSettings {
  eventId: string;
  participantId: string;
  participantsSound: number;
  selectedLanguage: string;
  gameSound: number;
}

export enum UserRoles {
  EVENT_PARTICIPANT = 'EVENT_PARTICIPANT',
  WORLD_ADMIN = 'WORLD_ADMIN',
  SUPER_ADMIN = 'SUPER_ADMIN',
}
